export default __webpack_public_path__ + "78a4230.png";